import { render, staticRenderFns } from "./CreateReturnAsnModal.vue?vue&type=template&id=b2b5285a"
import script from "./CreateReturnAsnModal.vue?vue&type=script&lang=js"
export * from "./CreateReturnAsnModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports